import { el, mount } from 'redom';

import application from 'application';

import { stringToSVG } from 'utilities';

import internalEventCodes from 'event-system/codes/internal';

import backArrowIconString from 'assets/images/back-arrow-icon.svg?raw';

const backArrowIcon = stringToSVG(backArrowIconString);

const modeClass = 'small-screen-mode-active';
const activeContentClass = 'small-screen-active-content-main';

class SmallScreenManagement {

  constructor() {

    this.activeElement = null;
    this.backButtonContainer = el('#goto-previous-screen-button-container', {
      style: {
        display: 'none'
      }
    }, [
      el('button#back-to-middle-panel-button', {
        onclick: this.backToMiddlePanel.bind(this)
      }, [backArrowIcon.cloneNode(true)])
    ]);

    mount(document.body, this.backButtonContainer);

  }

  hideBackButton() {

    application.eventSystem.internal.emit(internalEventCodes.UPDATE_MOBILE_HEADER_STATE, {
      displayBackButton: false
    });

  }

  showBackButton(previousPath) {

    application.eventSystem.internal.emit(internalEventCodes.UPDATE_MOBILE_HEADER_STATE, {
      displayBackButton: true,
      previousPath
    });

  }

  hideActiveElement() {

    this.activeElement && this.activeElement.classList.remove(activeContentClass);

  }

  showActiveElement() {

    this.activeElement && this.activeElement.classList.add(activeContentClass);

  }

  backToMiddlePanel() {

    document.body.classList.remove(modeClass);
    this.hideBackButton();
    this.hideActiveElement();

    this.activeElement = null;

    if (this.hide) {
      this.hide();
    }

  }

  tryActivateOverlay(element, previousPath, hide = () => {}) {

    if (application.domUtility.isMobile() === false) {
      return;
    }

    this.activeElement = element;
    document.body.classList.add(modeClass);
    this.showBackButton(previousPath);
    this.showActiveElement();
    this.hide = hide;

  }

}

export default SmallScreenManagement;